// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__+1iI6","error":"styles_error__UcvLi","warning":"styles_warning__dRrNU","ok":"styles_ok__c9C+H","pending":"styles_pending__enDMg"};